import React from 'react';
import { Sidebar } from './Sidebar';
import { useAuth } from '../context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

export function Layout({ menu }) {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  return (
    <main className="app">
      <Sidebar menu={menu} />
      <section className="content">
        <AnimatePresence mode="wait">
          <motion.div
            key={window.location.pathname}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            style={{ minHeight: '100%' }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </section>
    </main>
  );
}
